import { Box } from '@mui/material';
import React from 'react';

interface IIconTransitionProps {
	children: React.ReactNode;
	transitionProperty: string;
	apply: boolean;
	from?: string;
	to?: string;
}

const IconTransition: React.FC<IIconTransitionProps> = ({
	apply,
	children,
	transitionProperty,
	from = null,
	to = null
}) => (
	<Box
		sx={{
			transitionProperty,
			transitionDuration: '200ms',
			transitionTimingFunction: 'ease-in',
			display: 'inline-flex',
			...(from ? { [transitionProperty]: from } : {}),
			...(apply && to ? { [transitionProperty]: to } : {})
		}}
	>
		{children}
	</Box>
);

export default IconTransition;
